/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Chip, IconButton, makeStyles, TableCell, TableRow } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DetailsCollapse from './DetailsCollapse';

const useStyles = makeStyles({
  row: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  lastColumn: {
    borderRight: 'unset',
  },
  newColumn: {
    width: '1.5rem',
    borderRight: 'unset',
  },
  toggleColumn: {
    width: '1.5rem',
  },
  chip: {
    backgroundColor: '#BED05E',
  },
});

export default function CollapsibleRow({ columns, party, isNew }) {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <TableRow className={classes.row}>
        {columns.map((col, i, { length }) => {
          const lastColumnClass = length - 1 === i ? classes.lastColumn : '';
          return (
            <TableCell key={col.key} className={lastColumnClass}>
              {party[col.key]}
            </TableCell>
          );
        })}
        <TableCell className={classes.newColumn}>
          {isNew ? <Chip className={classes.chip} label={t('New')} /> : ''}
        </TableCell>
        <TableCell className={classes.toggleColumn}>
          <IconButton
            data-testid="icon-button"
            aria-label={t('row.expand')}
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <DetailsCollapse open={open} party={party} />
        </TableCell>
      </TableRow>
    </>
  );
}
